export default __webpack_public_path__ + "static/media/error.aa03cdae.svg";